<div class="auth-header">
  <div class="header-item logo-wrapper">
    <img src="/assets/images/strategies-icon-capital-logo.svg" alt="Cognia&trade; strategies">
  </div>
  <div class="header-item title">
    {{title}}
  </div>
  <div class="header-item menu-container">
    <div *ngIf="showMenu" class="menu-toggle">
      <button class="btn btn-styleless" type="button" pButton (click)="menu.toggle($event)">
          <span auto="user-menu" class="welcome-txt">Welcome,</span>
          <span>{{user.firstName}}</span>
          <i class="fa fa-caret-down"></i>
      </button>
      <p-menu #menu styleClass="auth-user-menu" popup="popup" [model]="items" appendTo="body"></p-menu>
    </div>
  </div>
</div>
